export const alluraAddress = '#220-744 W Hastings St Vancouver BC V6C 1A5 Canada';
export const alluraPhone = '604-707-6700';
